module.exports = __webpack_public_path__ + "static/media/coupon-cut.0711f359.svg";